import React, { useState } from "react";
import { Form, Container } from "react-bootstrap";
import {
  faCamera,
  faFileVideo,
  faCloudUploadAlt,
  faEyeSlash,
  faEye,
  faUpload,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Change_Password.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { SubmitChangePassword } from "../../features/support/slice";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";

function Change_Password() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [show, setShow] = useState("");

  const [files, setFiles] = useState({
    video_holding: null,
    identity_card: null,
    passbook_bank: null,
    latest_deposit_receipt_1: null,
    latest_deposit_receipt_2: null,
  });

  const [previews, setPreviews] = useState({
    video_holding: null,
    identity_card: null,
    passbook_bank: null,
    latest_deposit_receipt_1: null,
    latest_deposit_receipt_2: null,
  });

  const [fileErrors, setFileErrors] = useState({});

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      new_password: "",
      register_phone_number: "",
    },
  });

  const uploadFields = [
    {
      id: "video_holding",
      label: "Video holding : Identity Card, Passbook, Piece of paper with today's date written on it",
      mandatory: true,
      isVideo: true,
      isFile: true,
      accept: "video/*",
    },
    {
      id: "identity_card",
      label: "Identity Card",
      mandatory: true,
      accept: "image/*",
    },
    {
      id: "passbook_bank",
      label: "Passbook Bank",
      mandatory: true,
      accept: "image/*",
    },
    {
      id: "latest_deposit_receipt_1",
      label: "Latest Deposit Receipt Proof 1",
      mandatory: true,
      accept: "image/*",
    },
    {
      id: "latest_deposit_receipt_2",
      label: "Latest Deposit Receipt Proof 2",
      mandatory: false,
      accept: "image/*",
    },
  ];

  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    if (!file) return;

    setFiles((prev) => ({
      ...prev,
      [key]: file,
    }));

    setPreviews((prev) => ({
      ...prev,
      [key]: file.type.startsWith("image") || file.type.startsWith("video")
        ? URL.createObjectURL(file)
        : "file_uploaded",
    }));

    setFileErrors((prev) => ({
      ...prev,
      [key]: null,
    }));

    e.target.value = "";

  };

  const validateFiles = () => {
    const newErrors = {};

    if (!files.video_holding)
      newErrors.video_holding = "Video holding is required";
    if (!files.identity_card)
      newErrors.identity_card = "Identity Card is required";
    if (!files.passbook_bank)
      newErrors.passbook_bank = "Passbook Bank is required";
    if (!files.latest_deposit_receipt_1)
      newErrors.latest_deposit_receipt_1 = "Latest Deposit Receipt Proof 1 is required";

    setFileErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (data) => {
    try {
      if (!validateFiles()) return;

      const formData = new FormData();
      formData.append("new_password", data.new_password.trim());
      formData.append("register_phone_number", data.register_phone_number.trim());

      if (files.video_holding) formData.append("video_holding", files.video_holding);
      if (files.identity_card) formData.append("identity_card", files.identity_card);
      if (files.passbook_bank) formData.append("passbook_bank", files.passbook_bank);
      if (files.latest_deposit_receipt_1) formData.append("latest_deposit_receipt_1", files.latest_deposit_receipt_1);
      if (files.latest_deposit_receipt_2) formData.append("latest_deposit_receipt_2", files.latest_deposit_receipt_2);

      const res = await dispatch(SubmitChangePassword(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage(res?.payload?.data || "Password Change Request Submitted Successfully");
        setModalShow(true);
        reset();
        setFiles({
          video_holding: null,
          identity_card: null,
          passbook_bank: null,
          latest_deposit_receipt_1: null,
          latest_deposit_receipt_2: null,
        });
        setPreviews({
          video_holding: null,
          identity_card: null,
          passbook_bank: null,
          latest_deposit_receipt_1: null,
          latest_deposit_receipt_2: null,
        });
        setFileErrors({});
        setTimeout(() => {
          setModalShow(false);
          navigate(-1);
        }, 2000);
      } else {
        setModalMessage(res?.payload?.errors || "Submission failed. Please try again");
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }

    } catch (error) {
      console.error("Change Password Error:", error);
    }
  };

  return (
    <>
      <section className="Modify_Bank_Information Deposit_Not_Received_Form">
        <Common_white_header headingText={"Change Login Password"} />
        <Container>
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            <Form.Group className="form-group field_holder new_password">
              <Form.Label>
                New Password <span className="mandatory_estrics">*</span>
              </Form.Label>
              <div className="password-wrapper">
                <Form.Control
                  type={show ? "text" : "password"}
                  placeholder="Please Enter New Password"
                  {...register("new_password", {
                    required: "New password is required",
                    minLength: { value: 6, message: "Minimum 6 characters required" },
                    maxLength: { value: 20, message: "Maximum 20 characters allowed" },
                  })}
                />
                <span className="eye-icon" onClick={() => setShow(!show)}>
                  <FontAwesomeIcon icon={show ? faEye : faEyeSlash} />
                </span>
              </div>
              {errors.new_password && (
                <small className="text-danger">{errors.new_password.message}</small>
              )}
            </Form.Group>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                Register Phone Number <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please Enter Register Phone Number"
                {...register("register_phone_number", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Enter a valid 10-digit phone number",
                  },
                })}
              />
              {errors.register_phone_number && (
                <small className="text-danger">{errors.register_phone_number.message}</small>
              )}
            </Form.Group>

            {uploadFields.map((item) => (
              <Form.Group className="form-group field_holder" key={item.id}>
                <Form.Label>
                  {item.label}{" "}
                  {item.mandatory && (
                    <span className="mandatory_estrics">*</span>
                  )}
                </Form.Label>
                <div className="upload_box">
                  <input
                    type="file"
                    id={item.id}
                    hidden
                    accept={item.accept}
                    onChange={(e) => handleFileChange(e, item.id)}
                  />
                  <label htmlFor={item.id} className="photo_label">

                    {previews[item.id] && (
                      <div className="close-btn">
                        <FontAwesomeIcon
                          icon={faXmark}
                          onClick={(e) => {
                            // e.stopPropagation();
                            e.preventDefault();  // extra safety
                            setPreviews((prev) => ({
                              ...prev,
                              [item.id]: null,
                            }));
                          }}
                        />
                      </div>
                    )}
                    {previews[item.id] &&
                      previews[item.id] !== "file_uploaded" ? (

                      item.accept?.includes("video") ? (
                        <video
                          src={previews[item.id]}
                          className="uploaded_img_preview"
                          controls
                        />
                      ) : (
                        <img
                          src={previews[item.id]}
                          alt="Preview"
                          className="uploaded_img_preview"
                        />
                      )

                    ) : previews[item.id] === "file_uploaded" ? (
                      <div className="success_upload">
                        <FontAwesomeIcon
                          icon={faCloudUploadAlt}
                          style={{ color: "#28a745" }}
                        />
                        <span>Uploaded</span>
                      </div>

                    ) : (
                      <>
                        <FontAwesomeIcon icon={item.isFile ? faUpload : faCamera} />
                        <span>{item.isFile ? "Upload" : "Photo"}</span>
                      </>
                    )}
                  </label>
                </div>

                {fileErrors[item.id] && (
                  <small className="text-danger">{fileErrors[item.id]}</small>
                )}

              </Form.Group>
            ))}

            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Confirm"}
            </button>

          </Form>
        </Container>
      </section>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Change_Password;